export interface DiscoveryConfig {
  config: {
    [countryCode: string]: string;
  };
  rpsInstance: {
    [regionCode: string]: DiscoveryUrlsConfig | undefined;
  };
}

export interface DiscoveryUrlsConfig {
  crs: string;
}

export const PROD_DISCOVERY_CONFIG: DiscoveryConfig = {
  config: {
    ad: 'eu-02',
    ae: 'me-ae',
    am: 'eu-02',
    ar: 'us-ar',
    at: 'eu',
    ba: 'eu-02',
    bd: 'as-bd',
    bg: 'eu-02',
    bh: 'me-bh',
    bo: 'us',
    ci: 'eu-02',
    cl: 'us-cl',
    cr: 'us',
    cy: 'eu',
    cz: 'eu',
    de: 'eu',
    dk: 'eu',
    do: 'us',
    ec: 'us',
    eg: 'me-eg',
    es: 'eu-03',
    fi: 'eu-fi',
    ge: 'eu-02',
    gr: 'eu',
    gt: 'us',
    hk: 'as-hk',
    hn: 'us',
    hr: 'eu-02',
    hu: 'eu-hu',
    iq: 'me',
    it: 'eu-03',
    jo: 'me-jo',
    ke: 'eu-02',
    kg: 'eu-02',
    kh: 'as-kh',
    kw: 'me-kw',
    kz: 'eu-02',
    la: 'as-la',
    ma: 'eu-02',
    md: 'eu-02',
    me: 'eu-02',
    mm: 'as-mm',
    my: 'as-my',
    ng: 'eu-02',
    ni: 'us',
    no: 'eu-no',
    om: 'me-om',
    pa: 'us',
    pe: 'us',
    ph: 'as-ph',
    pk: 'as-pk',
    pl: 'eu-03',
    pt: 'eu-02',
    py: 'us',
    qa: 'me-qa',
    ro: 'eu-02',
    rs: 'eu-02',
    sa: 'me-sa',
    se: 'eu-se',
    sg: 'as-sg',
    sk: 'eu',
    sv: 'us',
    th: 'as-th',
    tn: 'eu-02',
    tr: 'me-tr',
    tw: 'as-tw',
    ua: 'eu-02',
    ug: 'eu-02',
    uy: 'us',
    ve: 'us',
  },
  rpsInstance: {
    as: {
      crs: 'https://vendor-api.as.restaurant-partners.com/',
    },
    'as-bd': {
      crs: 'https://vendor-api.as.restaurant-partners.com/',
    },
    'as-hk': {
      crs: 'https://vendor-api-hk.as.restaurant-partners.com/',
    },
    'as-kh': {
      crs: 'https://vendor-api.as.restaurant-partners.com/',
    },
    'as-la': {
      crs: 'https://vendor-api.as.restaurant-partners.com/',
    },
    'as-mm': {
      crs: 'https://vendor-api.as.restaurant-partners.com/',
    },
    'as-my': {
      crs: 'https://vendor-api-my.as.restaurant-partners.com/',
    },
    'as-ph': {
      crs: 'https://vendor-api-ph.as.restaurant-partners.com/',
    },
    'as-pk': {
      crs: 'https://vendor-api-pk.as.restaurant-partners.com/',
    },
    'as-sg': {
      crs: 'https://vendor-api-sg.as.restaurant-partners.com/',
    },
    'as-th': {
      crs: 'https://vendor-api-th.as.restaurant-partners.com/',
    },
    'as-tw': {
      crs: 'https://vendor-api-tw.as.restaurant-partners.com/',
    },
    eu: {
      crs: 'https://vendor-api.eu.restaurant-partners.com/',
    },
    'eu-02': {
      crs: 'https://vendor-api-02.eu.restaurant-partners.com/',
    },
    'eu-03': {
      crs: 'https://vendor-api-03.eu.restaurant-partners.com/',
    },
    'eu-fi': {
      crs: 'https://vendor-api.eu.restaurant-partners.com/',
    },
    'eu-hu': {
      crs: 'https://vendor-api.eu.restaurant-partners.com/',
    },
    'eu-no': {
      crs: 'https://vendor-api.eu.restaurant-partners.com/',
    },
    'eu-se': {
      crs: 'https://vendor-api-se.eu.restaurant-partners.com/',
    },
    me: {
      crs: 'https://vendor-api.me.restaurant-partners.com/',
    },
    'me-ae': {
      crs: 'https://vendor-api-ae.me.restaurant-partners.com/',
    },
    'me-bh': {
      crs: 'https://vendor-api-bh.me.restaurant-partners.com/',
    },
    'me-eg': {
      crs: 'https://vendor-api-eg.me.restaurant-partners.com/',
    },
    'me-jo': {
      crs: 'https://vendor-api-jo.me.restaurant-partners.com/',
    },
    'me-kw': {
      crs: 'https://vendor-api-kw.me.restaurant-partners.com/',
    },
    'me-om': {
      crs: 'https://vendor-api.me.restaurant-partners.com/',
    },
    'me-qa': {
      crs: 'https://vendor-api-qa.me.restaurant-partners.com/',
    },
    'me-sa': {
      crs: 'https://vendor-api-sa.me.restaurant-partners.com/',
    },
    'me-tr': {
      crs: 'https://vendor-api-tr.me.restaurant-partners.com/',
    },
    us: {
      crs: 'https://vendor-api.us.restaurant-partners.com/',
    },
    'us-ar': {
      crs: 'https://vendor-api-ar.us.restaurant-partners.com/',
    },
    'us-cl': {
      crs: 'https://vendor-api-cl.us.restaurant-partners.com/',
    },
  },
};
